module.exports = __webpack_public_path__ + "img/y-166.17252277.png";